import React, { useEffect, useState } from 'react';
import {Skeleton, Box, Grid, Typography} from "@mui/material";
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from "recharts";
import StyledPaper from "../common/styled-paper.component";
import ProductMultipleSelectCheckmarks from "./product-multiple-select-checkmarks.component";
import useAnalytics from '../../hooks/useAnalytics';
import EmptyIcon from "../../assets/images/empty-box.png";

import YearDatePicker from './year-date-picker.component';

var product_comparison_data_by_month = [
    { name: 'January' },
    { name: 'February' },
    { name: 'March' },
    { name: 'April' },
    { name: 'May' },
    { name: 'June' },
    { name: 'July' },
    { name: 'August' },
    { name: 'September' },
    { name: 'October' },
    { name: 'November' },
    { name: 'December' }
];

const generateRandomColor = () => {
    // Generate a random hex color
    const randomColor = `#${Math.floor(Math.random() * 0xFFFFFF).toString(16)}`;
    return randomColor.padEnd(7, '0'); // Ensure it's always 7 characters (including '#')
};
  
const isColorDark = (color) => {
    // Calculate luminance of the color
    const rgb = parseInt(color.slice(1), 16); // Convert hex to RGB
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >>  8) & 0xff;
    const b = (rgb >>  0) & 0xff;
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return luminance < 0.5;
};

const generateRandomDarkColor = () => {
    // Generate a random hex color
    const randomColor = generateRandomColor();
    if(!isColorDark(randomColor)) generateRandomDarkColor();
    return randomColor;
};

const ProductComparativeAnalysis = (props) => {

    const [ formatted_product_comparison_data_by_month, setFormattedProductComparisonDataByMonth ] = useState(null);
    const [ products_found, setProductsFound ] = useState(null);
    const [ products, setProducts ] = useState();
    const [ year, setYear ] = useState();
    const {getVerificationPerMonth, verification_per_month, isFetchVerificationPerMonth} = useAnalytics();

    useEffect(()=>{
        if(year == null) return;
        if(products == null) return;
        var productCodesArray = [];
        if(products.length != 0){
            productCodesArray = products.map(item => item.product_code);
        }
        getVerificationPerMonth(year, productCodesArray);
    }, [year, products])

    useEffect(()=>{
        if(verification_per_month == null) return;
        var productsFound = [];
        for(var i=0; i < verification_per_month.length; i++){
            var month = verification_per_month[i].month;
            var products = verification_per_month[i].product;
            products.map((product)=>{
                product_comparison_data_by_month[month] = {
                    ...product_comparison_data_by_month[month],
                    [product.product_name]: product.count
                }
                if(!productsFound.includes(product.product_name)){
                    productsFound.push(product.product_name);
                }
            });
        }
        setProductsFound(productsFound);
        setFormattedProductComparisonDataByMonth(product_comparison_data_by_month);
    }, [verification_per_month])

    return (
        <StyledPaper>
            <Grid container sx={{pb: 2}}>
                <Grid item xs={12} md={5}>
                    <Typography>Product Comparative Analysis</Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} lg={8}>
                            <ProductMultipleSelectCheckmarks onProductsChange={setProducts}/>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <YearDatePicker onYearChange={(res)=>setYear(res)} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {isFetchVerificationPerMonth ?
                <Skeleton variant="rounded" sx={{backgroundColor: "#d8d8fdbd"}} height={495} />
            :
                (!isFetchVerificationPerMonth && verification_per_month?.length === 0) ?
                    <Box sx={{height: 495, textAlign: "center", flexDirection: "column", 
                        justifyContent: "center", display: "flex", alignItems: "center", 
                    }}>
                        <img alt="empty-data-icon" src={EmptyIcon} width="110" style={{marginTop: "-84px"}} />

                        <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
                            No data available for the selected date range
                        </Typography>
                    </Box>
            :

                <ResponsiveContainer width="100%" height={610}>
                    <LineChart width={500} height={510} data={formatted_product_comparison_data_by_month} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip /> 
                        <Legend />
                        { products_found?.map((item)=>{
                            return(
                                <Line type="monotone" dataKey={item} stroke={generateRandomDarkColor()} strokeWidth={1.5} />
                            )
                        })}
                    </LineChart>
                </ResponsiveContainer>
            }
        </StyledPaper>
    )

}

export default ProductComparativeAnalysis;